/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CompanyBankAccountStatus {
  PENDING = 'PENDING',
  VALIDATION_SENT = 'VALIDATION_SENT',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  VALID = 'VALID',
  VALID_BUSSINESS_PARTNER = 'VALID_BUSSINESS_PARTNER',
  INVALID = 'INVALID',
}
